"use strict"

import angular from "angular"

angular
  .module("uCountitUiApp")

  .directive("exportPushConfig", () => ({
    restrict: "E",
    templateUrl: "app/admin/company/dataexport/push/push-config.html",
    controller: "PushConfigCtrl",

    scope: {
      form: "=",
      originalForm: "=",
    },
  }))
